import type React from 'react';

export const getLocationHash = (
  location: Location = window.location,
): string => {
  const hash = location.hash || '';
  return hash.startsWith('#') ? hash.slice(1) : hash;
};

export const isOnline = () => navigator.onLine;
export const isOffline = () => !isOnline();

export const stopPropagation = (e: React.MouseEvent<HTMLElement>) => {
  e.stopPropagation();
  e.preventDefault();
};

export const copyToClipboard = async (text: string) => {
  await navigator.clipboard.writeText(text);
};
